/* eslint-disable react/jsx-pascal-case */

import dayjs from "dayjs";
import React, { useEffect, useState, useRef } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    MultipleSelectorV2,
    Textarea,
    Switch,
    Select,
    JoditEditor
} from '../../ui/ot'
import UploadImg from "../UploadImg";
import News from "../../news/views/News";
import { useMenu } from "../controller/menu_controller";
import { usePermission } from "../controller/PermissionController";
import Divider from "../../ui/divider";
import { usePageManagement } from "../controller/page_management_controller";
import { useBlogCategory } from '../controller/blog_category_controller'
const language_culture_code = 'zh-tw'
const ArticleManagementForm = ({
    propsForm = null,
    propsValue = null,
    formReloadCount = 0,
    onFormFinish = () => { },
    propertyJsonShow = null,
    editcard

}) => {
    const [form] = Form.useForm();
    const [count, setCount] = useState(0);
    const [blogFieldId, setBlogFieldId] = useState();
    const youtubeDetectRef = useRef(setTimeout(() => { }, 0));
    const [show, setShow] = useState(true)
    const setFormValuesOtherThings = (formValues) => {
        //做一些你可能會用到其他component的資料整理
        let newFormValues = {
            ...formValues,
        };
        if (propsForm) {
            propsForm.setFieldsValue(newFormValues);
        } else {
            form.setFieldsValue(newFormValues);
        }
    };
    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊
        getPermissionChildrenData({
            classify_structure_id: 5,
        });
        getPageManagementData({

        })
        getBlogCategoryData({})
        getMenuData({});
        if (editcard) {
        }
    };
    const onFinish = (values) => {
        setShow(false)
        setTimeout(() => {
            let formValues = null;
            if (propsForm) {
                formValues = propsForm.getFieldsValue();
            } else {
                formValues = form.getFieldsValue();
            }
            onFormFinish({
                ...formValues,
            });
        }, 2000);
        setShow(true)
    };
    const onValuesChange = (value, { name, type }) => {

        let changeFormName = (name || "").split(".");
        if (changeFormName.includes("title")) {
            setCount((pre) => pre + 1);
        } else if (
            changeFormName.includes(
                "extermal_link_check_replace" ||
                changeFormName.includes(
                    "blog_type_classify_structure_type_blog_data"
                )
            )
        ) {
            setCount((pre) => pre + 1);
        }
        else if (changeFormName.includes("youtube_iframe")) {
            clearTimeout(youtubeDetectRef.current);
            youtubeDetectRef.current = setTimeout(onYoutubeDetect(name), 1000);
        }
        clearTimeout(youtubeDetectRef.current);
        // youtubeDetectRef.current = setTimeout(onYoutubeDetect, 1000);
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }
        // setFormValuesOtherThings(formValues);
    };
    const onYoutubeDetect = (name) => {
        let value = '';
        if (!!propsForm) {
            value = propsForm.getFieldValue(
                name
            );
        } else {
            value = form.getFieldValue(
                name
            );
        }
        let youtube_iframe = value
        let element = "";
        if (youtube_iframe !== "") {
            let stringhtml = youtube_iframe;
            let parser = new DOMParser();
            let parsedResult = parser.parseFromString(
                stringhtml,
                "text/html"
            );
            element = parsedResult.getElementsByTagName("iframe");
            for (let index = 0; index < element.length; index++) {
                const item = element[index];

                item.setAttribute("width", "100%");
                item.setAttribute("height", "100%");
            }
        }
        setFieldValue(name, element[0]?.outerHTML);
    };
    const getLanguageLabel = (language_culture_code) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        return label[language_culture_code];
    };
    const getLanguageName = ({ language_culture_code, obj_language_data }) => {
        let label = {
            "zh-tw": "中文",
            en: "英文",
        };
        let nameValue = obj_language_data.find((element) => {
            return element?.language_culture_code === language_culture_code;
        })?.language_culture_value;
        return nameValue || "";
    };

    const { getMenuData, MenuData } = useMenu({
        onBefore: () => { },
        onFinish: () => { },
    });
    const { PageManagementData, getPageManagementData } = usePageManagement({
        onFinish: () => { },
        onBefore: () => { },
    });
    const {
        BlogCategoryData,
        getBlogCategoryData
    } = useBlogCategory({
        onBefore: () => { },
        onFinish: () => {

        }
    })
    const setFieldValue = (name, value) => {
        if (propsForm) {
            propsForm.setValue(name, value);
        } else {
            form.setValue(name, value);
        }
    };
    const getAnyFormValue = (name, count) => {

        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldValue(name);
        } else {
            formValues = form.getFieldValue(name);
        }
        console.log({
            name, formValues
        })
        return formValues;
    };

    // 手動解析字串並更新值的函數
    function setValueByPath(obj, path, value) {
        const keys = path.split(".");
        let current = obj;
        keys.forEach((key, index) => {
            if (key.includes("[")) {
                const [arrayKey, arrayIndex] = key
                    .split(/[\[\]]/)
                    .filter(Boolean);
                if (index === keys.length - 1) {
                    current[arrayKey][parseInt(arrayIndex)] = value;
                } else {
                    current = current[arrayKey][parseInt(arrayIndex)];
                }
            } else {
                if (index === keys.length - 1) {
                    current[key] = value;
                } else {
                    current = current[key];
                }
            }
        });
        return obj;
    }



    const { getPermissionChildrenData, permissionChildrenData } = usePermission(
        {
            onBefore: () => { },
            onFinish: () => { },
        }
    );

    useEffect(() => {
        setDataInitialization();
    }, []);

    useEffect(() => {
        let formValues = null;
        if (propsForm) {
            formValues = propsForm.getFieldsValue();
        } else {
            formValues = form.getFieldsValue();
        }

    }, [formReloadCount]);

    return (
        <Row>
            <Col span={24}>
                <Form
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    layout="horizontal"
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"
                >
                    <Row>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                label="blog_id"
                                name={"blog_id"}
                                hidden={true}

                            >
                                <div></div>
                            </Form.Item>
                        </Col>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={4}

                                wrapperCol={20}
                                label="貼文標題"
                                name={'title'}
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "title"
                                        ]
                                }
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            "此為必填",
                                    },
                                ]}
                            >
                                <Input />
                            </Form.Item>
                        </Col>
                        <Col span={24}>
                            <Form.Item
                                label={"貼文分類"}
                                name={"blog_category_data"}
                                labelCol={4}
                                wrapperCol={20}
                            >
                                <MultipleSelectorV2
                                    options={BlogCategoryData.map(
                                        (value) => {
                                            return {
                                                label: getLanguageName(
                                                    {
                                                        language_culture_code:
                                                            language_culture_code,
                                                        obj_language_data:
                                                            value?.name_language_data,
                                                    }
                                                ),
                                                value: value?.category_id,
                                            };
                                        }
                                    )}
                                />
                            </Form.Item>
                        </Col>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                label="貼文內容"
                                name={'content'}
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "content"
                                        ]
                                }
                            >
                                <Textarea />
                            </Form.Item>
                        </Col>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                label={
                                    "連結設定"
                                }
                                name={"extermal_link_check_replace"}
                                valuePropName="checked"
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "extermal_link_check"
                                        ]
                                }
                            >
                                <Switch
                                    checkedChildren="外部連結"
                                    unCheckedChildren="內部連結"
                                    onChange={(e) => {
                                        let newValue = e.target.value ? "1" : "0"

                                        setFieldValue(`extermal_link_check`, newValue)
                                    }}
                                />
                            </Form.Item>
                        </Col>

                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={4}
                                wrapperCol={20}
                                label={
                                    getAnyFormValue(
                                        `extermal_link_check_replace`,
                                        count
                                    )
                                        ? "外部連結"
                                        : "內部連結"
                                }
                                name={'external_link'}
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "external_link"
                                        ]
                                }
                            >
                                {getAnyFormValue(
                                    `extermal_link_check_replace`,
                                    count
                                ) ? (
                                    <Input />
                                ) : (
                                    <Select
                                        placeholder="請選擇連結頁面"
                                        options={(
                                            PageManagementData ||
                                            []
                                        ).map(
                                            (
                                                value
                                            ) => {
                                                return {
                                                    label: getLanguageName(
                                                        {
                                                            language_culture_code:
                                                                language_culture_code,
                                                            obj_language_data:
                                                                value?.name_language_data,
                                                        }
                                                    ),
                                                    value: value?.page_id,
                                                };
                                            }
                                        )}
                                    />
                                )}
                            </Form.Item>
                        </Col>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.List
                                hidden={true}
                                name={`blog_type_classify_structure_type_blog_data`}
                            >
                                {(
                                    subfields,
                                    {
                                        add: testAdd,
                                    }
                                ) => (
                                    <Row
                                        hidden={
                                            true
                                        }
                                    >
                                        <Col
                                            span={
                                                24
                                            }
                                        >
                                            {subfields.map(
                                                (
                                                    subfield
                                                ) => {
                                                    return (
                                                        <Row>
                                                            <Col
                                                                span={
                                                                    8
                                                                }
                                                            >
                                                                <Form.Item
                                                                    label="file_id"
                                                                    name={`${subfield.name}.file_id`}
                                                                    hidden={true}

                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col
                                                                span={
                                                                    8
                                                                }
                                                            >
                                                                <Form.Item
                                                                    label="file_url"
                                                                    name={`${subfield.name}.file_url`}
                                                                    hidden={true}

                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                            <Col
                                                                span={
                                                                    8
                                                                }
                                                            >
                                                                <Form.Item
                                                                    label="file"
                                                                    name={`${subfield.name}.file`}
                                                                    hidden={true}

                                                                >
                                                                    <Input />
                                                                </Form.Item>
                                                            </Col>
                                                        </Row>
                                                    );
                                                }
                                            )}
                                        </Col>
                                    </Row>
                                )}
                            </Form.List>
                        </Col>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={
                                    4
                                }
                                wrapperCol={
                                    20
                                }
                                label={
                                    "上傳圖片"
                                }
                                name={`upload`}
                            >
                                <UploadImg
                                    defaultValue={getAnyFormValue(`blog_type_classify_structure_type_blog_data`, count)}
                                    onImagesChange={(value) => {
                                        setFieldValue(`blog_type_classify_structure_type_blog_data`, value)
                                    }}
                                />
                            </Form.Item>


                        </Col>

                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={
                                    4
                                }
                                wrapperCol={
                                    20
                                }
                                label={
                                    "Youtube連結"
                                }
                                name={"youtube_iframe"}
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "youtube_iframe"
                                        ]
                                }
                            >
                                <Textarea></Textarea>
                            </Form.Item>
                        </Col>
                        <Col
                            hidden={
                                true
                            }
                            span={
                                24
                            }
                        >
                            <Form.List
                                name={`blog_news_data`}
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "blog_news_data"
                                        ]
                                }
                            >
                                {(
                                    newsFields
                                ) => (
                                    // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                    <>
                                        {newsFields.map((
                                            newsField
                                        ) => (
                                            <>
                                                <Form.Item
                                                    // hidden
                                                    name={[
                                                        newsField?.name,
                                                        "news_id",
                                                    ]}
                                                >
                                                    {/* <Input /> */}
                                                </Form.Item>
                                            </>
                                        )
                                        )}
                                    </>
                                )}
                            </Form.List>
                        </Col>
                        {/* <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={
                                    4
                                }
                                wrapperCol={
                                    20
                                }
                                // hidden={ !propertyJsonShow ? false : !propertyJsonShow[ "blog_news_data" ]  }
                                hidden={true}
                                label={"最新消息"}
                                name={'blog_news_data'}
                            >
                                <News
                                    name={"blog_news_data"}
                                    defaultSize={
                                        10
                                    }
                                    showSwitch={
                                        true
                                    }
                                    propsShowColumns={[
                                        "news_title",
                                        "staff_name",
                                        "news_type_name",
                                        "news_time",
                                        "announce_time_end",
                                        "news_id",
                                        "option",
                                    ]}
                                    propsCheckSelectRowKeys={(getAnyFormValue(`blog_news_data`) || []).map((value) => value?.news_id)}
                                    propsCheckSelectedRowsInfo={[]}
                                    propsMode={false}
                                    showNewsType={
                                        true
                                    }
                                    onCheckSelectChange={(keys, infos) => {
                                        let newsIdData = (keys || [])?.map((val, index) => {
                                            return {
                                                news_id: val,
                                            };
                                        });
                                        setFieldValue(`blog_news_data`, newsIdData);
                                    }}
                                />
                            </Form.Item>
                        </Col> */}
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                labelCol={
                                    4
                                }
                                wrapperCol={
                                    20
                                }
                                label={
                                    "直播字幕"
                                }
                                // hidden={!propertyJsonShow? false: !propertyJsonShow[ "blog_room_data"]}
                                hidden={true}
                                name={"blog_room_data"}
                            >
                                <Switch
                                    checkedChildren="開啟"
                                    unCheckedChildren="關閉"
                                    defaultChecked={getAnyFormValue(
                                        `blog_room_data`,
                                        count
                                    )}
                                    onChange={(
                                        e
                                    ) => {
                                        if (
                                            e
                                        ) {
                                            setFieldValue(
                                                `blog_room_data`,
                                                [
                                                    {},
                                                ]
                                            );
                                        } else
                                            setFieldValue(
                                                `blog_room_data`,
                                                []
                                            );
                                    }}
                                />
                            </Form.Item>
                            <Form.List
                                name={`blog_room_data`}
                            >
                                {(
                                    subRoomFields,
                                    subRoomOpt
                                ) => (
                                    // <div style={{ display: 'flex', flexDirection: 'column', rowGap: 16 }}>
                                    <>
                                        {subRoomFields.map(
                                            (
                                                subRoomField
                                            ) => (
                                                <>
                                                    <Form.Item
                                                        hidden
                                                        name={[
                                                            subRoomField.name,
                                                            "blog_room_id",
                                                        ]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                    <Form.Item
                                                        hidden
                                                        name={[
                                                            subRoomField.name,
                                                            "room_id",
                                                        ]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </>
                                            )
                                        )}
                                    </>
                                )}
                            </Form.List>
                        </Col>
                        <Col
                            span={
                                24
                            }
                        >
                            <Form.Item
                                label={
                                    "詳細內容"
                                }
                                labelCol={
                                    4
                                }
                                wrapperCol={
                                    20
                                }
                                hidden={
                                    !propertyJsonShow
                                        ? false
                                        : !propertyJsonShow[
                                        "more_content"
                                        ]
                                }
                                name={"more_content"}
                            >
                                {
                                    show ? <Editor
                                        // propsValue={
                                        //     getAnyFormValue(`${field.name}.more_content`,count)
                                        // }
                                        // value={getAnyFormValue(
                                        //     `${field.name}.more_content`,
                                        //     count
                                        // )}
                                        propsValue={getAnyFormValue(
                                            `more_content`,
                                            count
                                        )}
                                        // name={`${field.name}.more_content`}

                                        onContentChange={(
                                            val
                                        ) => {
                                            setFieldValue(
                                                `more_content`,
                                                `${val}`
                                            );
                                        }}
                                    /> : <Input />}
                            </Form.Item>
                        </Col>
                    </Row>
                </Form >
            </Col >
        </Row >
    );
};

export default ArticleManagementForm;

const Editor = ({ propsValue = null, onContentChange = () => { } }) => {
    const [form] = Form.useForm();
    const [content, setContent] = useState("");
    const editor = useRef(null);
    const testref = useRef(propsValue)
    const config = {
        allowResizeTags: false,
        imageDefaultWidth: "100%",
        language: "zh_tw",
        i18n: {
            zh_tw: {
                Default: "預設",
                "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.":
                    "Copyright © XDSoft.net - Chupurnov Valeriy. All rights reserved.",
                Anchor: "Anchor",
                Margins: "外邊距（Margins）",
                top: "top",
                right: "right",
                bottom: "bottom",
                left: "left",
                Classes: "Classes",
                Src: "Src",
                Title: "Title",
                Link: "Link",
                file: "file",
                "Image properties": "圖片屬性",
                "Your code is similar to HTML. Keep as HTML?":
                    "你黏貼的文本是一段html代碼，是否保留源格式",
                "Paste as HTML": "html黏貼",
                "Insert as Text": "把html代碼視為普通文本",
                "Error on load list": "加載list錯誤",
                Break: "Pause",
                "No follow": "No follow",
                URL: "URL",
                Crop: "Crop",
                Default: "默認",
                Circle: "圓圈",
                Dot: "點",
                Quadrate: "方形",
                Find: "搜尋",
                "Insert className": "插入標籤名稱",
                "Press Alt for custom resizing": "按Alt自定義調整大小",
                "Find Next": "找下一個",
                "Find Previous": "找上一個",
                replace: "替代",
                "Line height": "行高",
            },
        },
        uploader: {
            insertImageAsBase64URI: true,
            imagesExtensions: ["jpg", "png", "jpeg", "gif", "svg", "webp"],
        },
    };

    const onChange = (content) => {
        testref.current = content
    };

    useEffect(() => {
        document.body.style.pointerEvents = "auto";
        setContent(propsValue);
    }, [propsValue]);
    useEffect(() => {
        return () => {
            onContentChange(testref.current)
        }
    }, [])
    return (
        <>
            <JoditEditor
                ref={editor}
                value={content}
                config={config}
                tabIndex={1} // tabIndex of textarea
                onBlur={(content) => onChange(content)} // preferred to use only this option to update the content for performance reasons
                height={1000}
                allowResizeX={true}
                allowResizeY={true}
            />
        </>
    );
};
